// const validateMobile = (rule, value, callback) => {
//   if (!value) {
//     callback(new Error('手机号码不能为空'))
//   } else {
//     if (/^1[2|3|4|5|6|7|8|9]\d{9}$/.test(value) && value.length === 11) {
//       callback()
//     } else {
//       callback(new Error('请输入正确的手机号码'))
//     }
//   }
// }

const validateMobile = (rule, value, callback) => {
  if (!value) {
    callback()
  } else {
    if (/^1[2|3|4|5|6|7|8|9]\d{9}$/.test(value) && value.length === 11) {
      callback()
    } else {
      callback(new Error('请输入正确的手机号码'))
    }
  }
}

const validateIdcard = (rule, value, callback) => {
  if (!value) {
    callback(new Error('身份证号码不能为空'))
  } else {
    if (/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)) {
      callback()
    } else {
      callback(new Error('请输入正确的身份证号码'))
    }
  }
}

const validateStudentCode = (rule, value, callback) => {
  if (!value) {
    callback(new Error('学号不能为空'))
  } else {
    if (/^\d{6,20}$/.test(value)) {
      callback()
    } else {
      callback(new Error('请输入正确的学号'))
    }
  }
}

// const validateEmail = (rule, value, callback) => {
//   if (!value) {
//     callback(new Error('邮箱地址不能为空'))
//   } else {
//     if (/^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/.test(value)) {
//       callback()
//     } else {
//       callback(new Error('请输入邮箱地址'))
//     }
//   }
// }

const validateEmail = (rule, value, callback) => {
  if (!value) {
    callback()
  } else {
    if (/^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/.test(value)) {
      callback()
    } else {
      callback(new Error('请输入邮箱地址'))
    }
  }
}
export {
  validateEmail,
  validateMobile,
  validateIdcard,
  validateStudentCode
}
